module.exports = __webpack_public_path__ + "img/chatbot.ac0e00d1.gif";